import { useState, type Dispatch, type SetStateAction } from "react";

/**
 * A local draft of `source`, reset back to it every time `open` flips to
 * true — the shared pattern behind every "edit locally, commit only on Done"
 * modal in this app (translation editors, the custom cancellation-policy
 * builder). Resetting here, during render, avoids the extra render + flicker
 * an effect-based reset would cost.
 */
export function useDraftOnOpen<T>(open: boolean, source: T): [T, Dispatch<SetStateAction<T>>] {
  const [draft, setDraft] = useState(source);
  const [prevOpen, setPrevOpen] = useState(open);
  if (open !== prevOpen) {
    setPrevOpen(open);
    if (open) setDraft(source);
  }
  return [draft, setDraft];
}
